export const CHECKOUT_PASSWORDLESS_VERSION = "checkout-v2-passwordless";
export const DEFAULT_CHECKOUT_VERSION = "pagarme-v5";

// `isFirstAccessFlowErrored`: não conseguimos perguntar a flag (rede/VPN). O fluxo com senha foi
// descontinuado, então erro segue o fluxo vigente; flag respondendo `false` continua sendo o kill switch.
export const buildCheckoutMode = ({
  isFirstAccessFlowResolved,
  isFirstAccessFlowEnabled,
  isFirstAccessFlowErrored = false,
}) => ({
  passwordless: Boolean(
    isFirstAccessFlowResolved &&
      (isFirstAccessFlowEnabled || isFirstAccessFlowErrored)
  ),
});

export const getCheckoutVersion = isPasswordlessCheckout =>
  isPasswordlessCheckout
    ? CHECKOUT_PASSWORDLESS_VERSION
    : DEFAULT_CHECKOUT_VERSION;

export const getJusbillSubscriptionPath = ({
  paymentMethod,
  isPasswordlessCheckout,
}) => {
  const basePath = paymentMethod === "pix" ? "/subscriptions/pix" : "/subscriptions";
  return `${basePath}${isPasswordlessCheckout ? "/v2" : ""}`;
};

export const buildCheckoutValues = ({
  values,
  cardHash,
  urlParams,
  isPasswordlessCheckout,
}) => ({
  ...values,
  ...(cardHash !== undefined ? { card_hash: cardHash } : {}),
  ...(urlParams !== undefined ? { urlParams } : {}),
  version: getCheckoutVersion(isPasswordlessCheckout),
});

export const resolveCheckoutPlanId = ({ coupom, plan }) => {
  // cupom válido não implica plan_id: o tier selecionado pode não ter
  // cupom no catálogo (buildCatalogCheckoutCoupom devolve plan_id undefined nesse caso), sem que
  // isso seja um erro — cai pro gateway_id do plano, mesmo caminho de "sem cupom".
  if (coupom?.is_valid && coupom.plan_id) {
    return coupom.plan_id;
  }

  if (
    plan?.gateway_id === undefined ||
    plan?.gateway_id === null ||
    plan?.gateway_id === ""
  ) {
    throw new Error("Plano sem gateway_id");
  }

  return String(plan?.gateway_id);
};

export const buildCheckoutRegisterPayload = ({
  values,
  isPasswordlessCheckout,
}) => {
  const {
    card_number: _,
    card_cvv: __,
    card_expiration: ___,
    card_hash,
    urlParams,
    version,
    password,
    confirmation_password,
    ...registerValues
  } = values;

  return {
    ...registerValues,
    ...(!isPasswordlessCheckout ? { password, confirmation_password } : {}),
    card_hash,
    urlParams,
    version: isPasswordlessCheckout
      ? CHECKOUT_PASSWORDLESS_VERSION
      : version,
    requires_first_access: !!isPasswordlessCheckout,
  };
};
